import { APICore } from './apiCore'

const api = new APICore()

function getConfigsInfotools (params) {
  const baseUrl = '/config-infotools'
  return api.get(baseUrl, params)
}

function getConfigInfotools (id) {
  const baseUrl = `/config-infotools/${id}`
  return api.get(baseUrl, {})
}

function addConfigInfotools (params) {
  const baseUrl = '/config-infotools'
  return api.create(baseUrl, params)
}

function updateConfigInfotools (params) {
  const baseUrl = '/config-infotools'
  return api.update(baseUrl, params)
}

function deleteConfigInfotools (params) {
  const baseUrl = '/config-infotools'
  return api.delete(baseUrl, params)
}

export { getConfigsInfotools, getConfigInfotools, addConfigInfotools, updateConfigInfotools, deleteConfigInfotools }
